import {Injectable, isDevMode} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MatTableHelperService {

  constructor() {
  }

  isAllSelected(selectionModelLength: number, filteredDataLength: number): boolean {
    const result = selectionModelLength === filteredDataLength;
    // if (isDevMode())
      // console.warn('selectionModelLength=' + selectionModelLength + ' filteredDataLength=' + filteredDataLength + ' isAllSelected=' + result);

    return result;
  }
}
